import { useEffect, useState } from "react";
import { Stack, MenuItem } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useParams, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { useTheme } from "@emotion/react";
import Select from "react-select";

import { FormProvider, RHFTextField } from "../../../components/hook-form";
import MyCkEditor from "../../../components/hook-form/MyCkEditor";
import { useForm } from "react-hook-form";

export default function EditAnnouncement() {
  const theme = useTheme();
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [loading, setLoading] = useState(false);
  const [dataForDesc, setDataForDesc] = useState("");

  const [type, setType] = useState("none");
  const [list, setList] = useState([]);
  const [valueId, setValueId] = useState(null);

  const methods = useForm({
    defaultValues: {
      title: "",
      link: "none",
      isActive: true,
    },
  });

  const { handleSubmit, reset, setValue } = methods;

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_LIVE_URL}/adminPanel/getAnnouncementById/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const json = await res.json();

        if (json.status) {
          const data = json.data;

          reset({
            title: data.title,
            link: data.link || "none",
            isActive: data.isActive,
          });

          setType(data.link || "none");
          setDataForDesc(data.description || "");

          if (data.linkWith) {
            setValueId(data.linkWith);
          }
        } else {
          toast.error("Failed to load announcement");
        }
      } catch (err) {
        toast.error("Error loading announcement");
      }
    }

    if (id) fetchData();
  }, [id]);

  useEffect(() => {
    if (type && type !== "none") {
      async function fetchDetails() {
        const response = await fetch(
          `${process.env.REACT_APP_LIVE_URL}/adminPanel/${type === "batch"
            ? "getBatchDropdownList"
            : "getallTestSeriesdetails"
          }`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const json = await response.json();
        setList(json?.data || []);
      }

      fetchDetails();
    }
  }, [type]);

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      const reqObject = {
        title: data.title,
        description: dataForDesc,
        link: data.link,
        linkWith:
          data.link !== "none" ? valueId?._id : "",
        isActive: data.isActive,
      };

      const config = {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.put(
        `${process.env.REACT_APP_LIVE_URL}/adminPanel/updateAnnouncement/${id}`,
        reqObject,
        config
      );

      if (response.data.status) {
        toast.success("Announcement Updated Successfully");

        setTimeout(() => {
          navigate("/dashboard/announcements");
        }, 800);
      } else {
        toast.error(response.data.msg);
      }
    } catch (error) {
      toast.error("Update failed");
    }

    setLoading(false);
  };

  return (
    <Stack spacing={3} px={5}>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3} sx={{ width: "70%" }}>

          <RHFTextField name="title" label="Title" />

          <RHFTextField
            name="link"
            label="Link Announcement"
            select
            onChange={(e) => {
              setType(e.target.value);
              setValue("link", e.target.value);
            }}
          >
            <MenuItem value="none">None</MenuItem>
            <MenuItem value="batch">Batch</MenuItem>
            <MenuItem value="testSeries">Test Series</MenuItem>
          </RHFTextField>

          {type !== "none" && (
            <Select
              options={list}
              value={valueId}
              isMulti={false}
              onChange={(value) => setValueId(value)}
              getOptionLabel={(option) =>option.batch_name || option.title || option.name}
              getOptionValue={(option) => option._id}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
            />
          )}

          <MyCkEditor
            dataForDesc={dataForDesc}
            setDataForDesc={setDataForDesc}
          />

          <RHFTextField name="isActive" label="Status" select>
            <MenuItem value={true}>Active</MenuItem>
            <MenuItem value={false}>Inactive</MenuItem>
          </RHFTextField>

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={loading}
            sx={{
              bgcolor: theme.palette.primary.mainTheme,
              marginTop: "5%",
            }}
          >
            Update
          </LoadingButton>
        </Stack>
      </FormProvider>

      <ToastContainer position="bottom-center" autoClose={1000} />
    </Stack>
  );
}